/* Lamberty Munich · Warenkorbseite (sections/lm-cart.liquid), Owner 08.10.2026 Runde 6-8.
   Lieferweiche, Versandkosten, Gesamtsumme, Zoelle, Lieferzeit, Geschenk, Mengen, Rabattcode.
   Runde 8: Geschenkoption und Rabattcode nur bei Direktlaendern (A). Rabattcodes gehen ueber
   /cart/update.js {discount} in den Shopify-Warenkorb und damit in den Checkout (getestet 08.10.).
   Geschenkkarten sind im Shop derzeit nicht aktiv (Checkout zeigt nur "Rabattcode"); der Warenkorb
   koennte sie ohnehin nicht vorab annehmen, sie wuerden an der Kasse eingeloest.
   Laenderdaten aus window.LMDest (assets/lm-cart-delivery.js). Artikel bleiben immer im Warenkorb.

   Versandkosten = Shopify-Versandprofil (Admin-Abfrage 08.10.2026):
     Zone A (alle uebrigen Direktlaender) kostenlos
     Zone B USA, Kanada: 55 € unter 200 €, ab 200 € kostenlos
     Zone C Australien, Hongkong, Japan, Neuseeland, Singapur: 75 €
   Lieferzeiten = Seite Lieferung & Rueckgabe. Bei Aenderungen dort hier nachziehen.
   v27 20.10.2026: FR-Zweig (data-lang fr, Texttabelle TXT.fr, Laenderphrasen aus window.LMDest.toPhrase).
*/
(function () {
  if (window.customElements.get('lm-cart')) return;

  var ZONE_B = ['US', 'CA'];
  var ZONE_C = ['AU', 'HK', 'JP', 'NZ', 'SG'];
  var ETA_24 = 'AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE MC CH IS LI NO'.split(' ');

  /* DE = Owner-Wortlaut (B/C aus Runde 3, ohne den Satz "kann nicht in den Warenkorb", da die
     Artikel jetzt im Warenkorb bleiben). EN = Vorschlag Claude. */
  var TXT = {
    de: {
      A: 'Wir liefern direkt {to}.',
      B: 'Leider liefern wir nicht direkt {to}. {To} können unsere Waren nur über Wolf & Badger bestellt werden.',
      C: 'Leider liefern wir noch nicht {to}. Bitte nehmen Sie Kontakt zu uns auf und wir schauen nach einer Lösung für Sie.',
      GEO: 'Wählen Sie Ihr Zielland, um die verfügbaren Liefermöglichkeiten anzuzeigen.',
      CHOOSE: 'Lieferland wählen',
      FREE: 'Kostenlos',
      DUTY: 'zzgl. Zölle und Einfuhrabgaben (falls zutreffend)',
      ETA_24: 'Voraussichtliche Lieferzeit: 2–4 Werktage ab Versand',
      ETA_23: 'Voraussichtliche Lieferzeit: 2–3 Werktage ab Versand',
      ETA_VAR: 'Voraussichtliche Lieferzeit: je nach Zielland und Zollabfertigung',
      MAIL_SUBJ: 'Lieferanfrage – {country}',
      MAIL_INTRO: 'Guten Tag,\n\nich möchte folgende Artikel {to} bestellen:\n',
      MAIL_SUB: 'Zwischensumme',
      MAXED: 'Sie haben bereits das letzte verfügbare Tuch in den Warenkorb gelegt.',
      CODE_EMPTY: 'Bitte geben Sie einen Code ein.',
      CODE_OK: 'Der Code {code} wurde angewendet.',
      CODE_BAD: 'Der Code {code} ist für diesen Warenkorb nicht gültig.',
      CODE_ERR: 'Der Code konnte gerade nicht geprüft werden. Bitte versuchen Sie es erneut.',
      MAIL_END: '\nName:\nLieferadresse:\nTelefon:\n',
      /* Teillieferung (Owner 09./10.10.2026, Konzept §4a) */
      SPLIT_FREE: 'Ihre vorrätigen Tücher versenden wir sofort. Die Tücher auf Bestellung folgen kostenlos in 4–6 Wochen.',
      SPLIT_ALL: 'Gesamtlieferung: alle Tücher zusammen in 4–6 Wochen',
      SPLIT_PART: 'Teillieferung: vorrätige Tücher sofort, Tücher auf Bestellung in 4–6 Wochen',
      SPLIT_SECOND: 'Zweite Sendung {fee}',
      BAR_ONE: 'Noch {x} bis zu einem kostenlosen Versand.',
      BAR_MIX: 'Noch {x} bis zu einer kostenlosen Gesamtlieferung. Bei Teillieferung ist eine Sendung kostenlos.',
      BAR_MIX_LOW: 'Noch {x} bis zu einer kostenlosen Gesamtlieferung. Bei Teillieferung kosten beide Sendungen je {fee}.',
      BAR_GRACE: 'Sie liegen knapp unter 200 €. Den Versand übernehmen wir trotzdem.',
      SPLIT_ERR: 'Die Lieferart konnte gerade nicht gespeichert werden. Bitte wählen Sie sie erneut oder laden Sie die Seite neu.',
      SPLIT_RETRY: 'Erneut versuchen',
      BAR_MIX_FREE: 'Gesamtlieferung kostenlos. Bei Teillieferung kostet die zweite Sendung {fee}.'
    },
    en: {
      A: 'We ship directly {to}.',
      B: "Unfortunately, we don't ship directly {to}. Orders {to} can only be placed via Wolf & Badger.",
      C: "Unfortunately, we don't ship {to} yet. Please get in touch and we will look for a solution for you.",
      GEO: 'Choose your destination to view the available delivery options.',
      CHOOSE: 'Choose country',
      FREE: 'Free',
      DUTY: 'plus customs duties and import taxes, if applicable',
      ETA_24: 'Estimated delivery: 2–4 working days from dispatch',
      ETA_23: 'Estimated delivery: 2–3 working days from dispatch',
      ETA_VAR: 'Estimated delivery: depends on destination and customs clearance',
      MAIL_SUBJ: 'Delivery request – {country}',
      MAIL_INTRO: 'Hello,\n\nI would like to order the following items for delivery {to}:\n',
      MAIL_SUB: 'Subtotal',
      MAXED: 'You have already added the last available scarf to your basket.',
      CODE_EMPTY: 'Please enter a code.',
      CODE_OK: 'The code {code} has been applied.',
      CODE_BAD: 'The code {code} is not valid for this basket.',
      CODE_ERR: 'The code could not be checked just now. Please try again.',
      MAIL_END: '\nName:\nDelivery address:\nPhone:\n',
      SPLIT_FREE: 'We will send your in-stock scarves straight away. Your made-to-order scarves will follow free of charge in 4–6 weeks.',
      SPLIT_ALL: 'Complete delivery: all scarves together in 4–6 weeks',
      SPLIT_PART: 'Split delivery: in-stock scarves now, made-to-order scarves in 4–6 weeks',
      SPLIT_SECOND: 'Second shipment {fee}',
      BAR_ONE: '{x} away from free shipping.',
      BAR_MIX: '{x} away from free complete delivery. With split delivery, one shipment is free.',
      BAR_MIX_LOW: '{x} away from free complete delivery. With split delivery, each shipment costs {fee}.',
      BAR_GRACE: 'You are just under €200. Shipping is on us.',
      SPLIT_ERR: 'Your delivery option could not be saved just now. Please select it again or reload the page.',
      SPLIT_RETRY: 'Try again',
      BAR_MIX_FREE: 'Complete delivery is free. With split delivery, the second shipment costs {fee}.'
    },
    /* v27 20.10.2026: FR = fr.md Abschnitt 18 (v2.5) */
    fr: {
      A: 'Nous livrons directement {to}.',
      B: 'Nous ne livrons malheureusement pas directement {to}. Pour cette destination, nos articles ne peuvent être commandés qu’auprès de Wolf & Badger.',
      C: 'Nous ne livrons malheureusement pas encore {to}. Contactez-nous : nous chercherons volontiers une solution avec vous.',
      GEO: 'Choisissez votre pays de livraison pour afficher les options disponibles.',
      CHOOSE: 'Choisir un pays de livraison',
      FREE: 'Offerte',
      DUTY: 'Droits de douane et taxes à l’importation en sus, le cas échéant',
      ETA_24: 'Délai de livraison estimé : 2 à 4 jours ouvrés à compter de l’expédition',
      ETA_23: 'Délai de livraison estimé : 2 à 3 jours ouvrés à compter de l’expédition',
      ETA_VAR: 'Délai de livraison estimé : variable selon la destination et le dédouanement',
      MAIL_SUBJ: 'Demande de livraison – {country}',
      MAIL_INTRO: 'Bonjour,\n\nJe souhaiterais commander les articles suivants pour une livraison {to} :\n',
      MAIL_SUB: 'Sous-total',
      MAXED: 'Vous avez déjà ajouté à votre panier le dernier exemplaire disponible.',
      CODE_EMPTY: 'Veuillez saisir un code.',
      CODE_OK: 'Le code {code} a été appliqué.',
      CODE_BAD: 'Le code {code} n’est pas valable pour ce panier.',
      CODE_ERR: 'Impossible de vérifier ce code pour le moment. Veuillez réessayer.',
      MAIL_END: '\nNom :\nAdresse de livraison :\nTéléphone :\n',
      SPLIT_FREE: 'Nous expédions immédiatement vos foulards en stock. Ceux confectionnés sur commande suivront sous 4 à 6 semaines, sans frais supplémentaires.',
      SPLIT_ALL: 'Livraison groupée : tous les foulards ensemble sous 4 à 6 semaines',
      SPLIT_PART: 'Livraison en deux envois : les foulards en stock immédiatement, ceux confectionnés sur commande sous 4 à 6 semaines',
      SPLIT_SECOND: 'Second envoi : {fee}',
      BAR_ONE: 'Plus que {x} pour bénéficier de la livraison offerte.',
      BAR_MIX: 'Plus que {x} pour bénéficier d’une livraison groupée offerte. Avec deux envois, l’un d’eux est offert.',
      BAR_MIX_LOW: 'Plus que {x} pour bénéficier d’une livraison groupée offerte. Avec deux envois, chacun est facturé {fee}.',
      BAR_GRACE: 'Votre commande est légèrement inférieure à 200 € : nous vous offrons néanmoins la livraison.',
      SPLIT_ERR: 'Votre mode de livraison n’a pas pu être enregistré. Veuillez le sélectionner à nouveau ou recharger la page.',
      SPLIT_RETRY: 'Réessayer',
      BAR_MIX_FREE: 'La livraison groupée est offerte. Avec deux envois, le second est facturé {fee}.'
    }
  };

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var intPart = parts[0];
    var withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(fmt || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* Zweite Sendung (Teillieferung): Variante je Zone (Produkt lm-second-shipment) */
  var FEE_VAR = { B: 50770671829040, C: 50770671861808 };
  var FEE_AMT = { B: 5500, C: 7500 };
  var HOLD_KEY = 'lmSplitHold';
  var FREE_MIN = 19500, FREE_SHOWN = 20000;
  function zoneOf(code) { return ZONE_B.indexOf(code) > -1 ? 'B' : (ZONE_C.indexOf(code) > -1 ? 'C' : 'A'); }

  function shipping(code, subtotal) {
    /* Owner 10.10.: Kulanz, kostenlos schon ab 195 € (Shop-Rate), angezeigt bleibt 200 € */
    if (ZONE_B.indexOf(code) > -1) return subtotal >= FREE_MIN ? 0 : 5500;
    if (ZONE_C.indexOf(code) > -1) return 7500;
    return 0;
  }

  class LmCart extends HTMLElement {
    connectedCallback() {
      if (!window.LMDest) { var self0 = this; setTimeout(function () { self0.connectedCallback(); }, 50); return; }
      if (this._ready) return;
      this._ready = true;
      this.l = this.dataset.lang === 'de' ? 'de' : (this.dataset.lang === 'fr' ? 'fr' : 'en');
      this.t = TXT[this.l];
      this.select = this.querySelector('[data-lm-country]');
      this.bindQty();
      /* Review 10.10.: Kasse gesperrt, solange Lieferart/Zweite Sendung geschrieben wird */
      this.addEventListener('submit', function (e) { if (this.classList.contains('is-locked') || this.classList.contains('is-held')) e.preventDefault(); }.bind(this), true);
      this.addEventListener('click', function (e) {
        if ((this.classList.contains('is-locked') || this.classList.contains('is-held')) && e.target.closest('button[name="checkout"], [data-lm-express]')) { e.preventDefault(); e.stopPropagation(); return; }
        /* Review Runde 3: Wiederholen nach Fehler, hebt die Sperre auf und gleicht den Warenkorb erneut ab */
        if (e.target.closest('[data-lm-split-retry]')) {
          e.preventDefault();
          try { sessionStorage.removeItem(HOLD_KEY); } catch (x) {}
          var me = this; this.lock(true);
          this.refresh().catch(function () { me.lock(false); });
        }
      }.bind(this), true);
      this.bindGift();
      this.bindCode();
      if (window.__lmCartFlash) { this.flash(window.__lmCartFlash.k, window.__lmCartFlash.ok, window.__lmCartFlash.code); window.__lmCartFlash = null; }
      if (!this.select) return; /* leerer Warenkorb */
      this.fill();
      var self = this;
      this.select.addEventListener('change', function () {
        var c = self.select.value;
        if (!c) return;
        self.userPicked = true;
        window.LMDest.setCartChoice(c);
        self.render(c);
        window.LMDest.updateLocalization(c).then(function (changed) { if (changed) self.refresh(); });
      });
      window.LMDest.resolveCountry().then(function (c) {
        /* Review 10.10.2026: spätes IP-Ergebnis überschreibt keine inzwischen getroffene Auswahl */
        if (self.userPicked) return;
        self.render(c);
        if (c) window.LMDest.updateLocalization(c).then(function (changed) { if (changed) self.refresh(); });
      });
    }

    fill() {
      var l = this.l, D = window.LMDest;
      var list = D.ALL.map(function (c) { return { c: c, n: D.countryName(c, l) }; });
      list.sort(function (a, b) { return a.n.localeCompare(b.n, l); });
      var html = '<option value="">' + esc(this.t.CHOOSE) + '</option>';
      list.forEach(function (x) { html += '<option value="' + x.c + '">' + esc(x.n) + '</option>'; });
      this.select.innerHTML = html;
    }

    render(code) {
      var D = window.LMDest, t = this.t, l = this.l;
      var st = D.stateOf(code);
      this.select.value = code || '';
      this.dataset.state = st;
      var to = code ? D.toPhrase(code, l) : '';
      var To = to ? to.charAt(0).toUpperCase() + to.slice(1) : '';
      var msg = this.querySelector('[data-lm-msg]');
      msg.textContent = (t[st] || '').split('{to}').join(to).split('{To}').join(To);

      var subtotal = parseInt(this.dataset.subtotal || '0', 10);
      var fmt = this.dataset.moneyFormat;
      var shipEl = this.querySelector('[data-lm-ship]');
      var totalEl = this.querySelector('[data-lm-total]');
      var duty = this.querySelector('[data-lm-duty]');
      var eta = this.querySelector('[data-lm-eta]');
      if (st === 'A') {
        var s = shipping(code, subtotal);
        /* Zweite Sendung (Teillieferung) ist eine eigene Position: im Versand mit ausweisen, damit die Summen aufgehen */
        var sb = this.querySelector('[data-lm-split]');
        var feeNow = sb ? parseInt(sb.dataset.fee || '0', 10) : 0;
        shipEl.textContent = (s + feeNow) === 0 ? t.FREE : formatMoney(s + feeNow, fmt);
        totalEl.textContent = formatMoney(subtotal + s, fmt);
        var nonEU = D.EU.indexOf(code) === -1;
        duty.textContent = t.DUTY; duty.hidden = !nonEU;
        eta.textContent = ETA_24.indexOf(code) > -1 ? t.ETA_24 : ((code === 'US' || code === 'CA') ? t.ETA_23 : t.ETA_VAR);
        eta.hidden = false;
      } else {
        shipEl.textContent = '–';
        totalEl.textContent = formatMoney(subtotal, fmt);
        duty.hidden = true;
        eta.hidden = true;
      }

      this.querySelectorAll('[data-lm-cta]').forEach(function (b) { b.hidden = b.getAttribute('data-lm-cta') !== st; });
      var ex = this.querySelector('[data-lm-express]');
      if (ex) ex.hidden = st !== 'A';
      var gw = this.querySelector('[data-lm-gift-wrap]');
      if (gw) gw.hidden = st !== 'A';
      this.querySelectorAll('[data-lm-only-a]').forEach(function (x) { x.hidden = st !== 'A'; });
      /* Owner 10.10.2026: Auf Bestellung nur in Direktlaender, Hinweis bei Wolf-&-Badger-Land */
      this.querySelectorAll('[data-lm-mto-no]').forEach(function (x) { x.hidden = st !== 'B'; });
      /* Owner 11.10.2026: bei W&B-Land zählen Tücher auf Bestellung nicht zur Summe. W&B-Knopf nur, wenn ein vorrätiges Tuch im Warenkorb liegt. */
      var mtoLis = this.querySelectorAll('.lm-cart__item[data-lm-mto]');
      var offB = st === 'B' && mtoLis.length > 0;
      var mtoSum = 0;
      mtoLis.forEach(function (li) { li.classList.toggle('is-unavail', st === 'B'); mtoSum += parseInt(li.getAttribute('data-lm-line') || '0', 10); });
      var subEl = this.querySelector('[data-lm-subtotal]');
      if (subEl) subEl.textContent = formatMoney(parseInt(subEl.getAttribute('data-v') || '0', 10) - (offB ? mtoSum : 0), fmt);
      if (offB) {
        totalEl.textContent = formatMoney(Math.max(0, subtotal - mtoSum), fmt);
        var availN = this.querySelectorAll('.lm-cart__item:not([data-lm-mto])').length;
        var wbBtn = this.querySelector('[data-lm-cta="B"]');
        if (wbBtn) wbBtn.hidden = availN === 0;
      }
      if (st === 'C') this.querySelector('[data-lm-cta="C"]').href = this.mailto(code);
      this.renderSplit(code, st);
    }

    /* Teillieferung und Hinweisleiste (Konzept §4a). Ändert den Warenkorb nur, wenn nötig, danach Abschnitt neu laden. */
    renderSplit(code, st) {
      var self = this, t = this.t, fmt = this.dataset.moneyFormat;
      var box = this.querySelector('[data-lm-split]');
      var bar = this.querySelector('[data-lm-freebar]');
      var err = this.querySelector('[data-lm-split-err]');
      if (!box) return;
      var body = box.querySelector('[data-lm-split-body]');
      var mixed = box.dataset.mixed === '1';
      var fee = parseInt(box.dataset.fee || '0', 10);
      var choice = box.dataset.choice || '';
      var subtotal = parseInt(this.dataset.subtotal || '0', 10);
      var goods = subtotal - fee;
      var zone = zoneOf(code);
      /* alle Positionen „Zweite Sendung“: key|menge|variante */
      var lines = (box.dataset.feeList || '').split(',').filter(Boolean).map(function (x) {
        var a = x.split('|'); return { key: a[0], qty: parseInt(a[1], 10) || 0, v: parseInt(a[2], 10) || 0 };
      });
      box.hidden = true; bar.hidden = true; body.innerHTML = '';
      if (this._splitBusy) return;
      /* Review 10.10.: nach einem fehlgeschlagenen Schreibvorgang keine automatische Wiederholung (2 Minuten) */
      var hold = false;
      try { hold = Date.now() - parseInt(sessionStorage.getItem(HOLD_KEY) || '0', 10) < 120000; } catch (e) {}
      this.classList.remove('is-held');
      if (err) {
        err.hidden = !hold;
        err.innerHTML = hold ? esc(t.SPLIT_ERR) + ' <button type="button" class="lm-cart__split-retry" data-lm-split-retry>' + esc(t.SPLIT_RETRY) + '</button>' : '';
      }

      /* Sollzustand Gebühr: genau eine Position der richtigen Zonen-Variante mit Menge 1, nur bei
         Direktland + gemischt + Zone mit Versandkosten + gewählter Teillieferung. Sonst keine. */
      var wantFee = st === 'A' && mixed && zone !== 'A' && choice === 'Teillieferung';
      var target = wantFee ? FEE_VAR[zone] : 0;
      var upd = {}, need = false, kept = false;
      lines.forEach(function (ln) {
        if (target && !kept && ln.v === target) { kept = true; if (ln.qty !== 1) { upd[ln.key] = 1; need = true; } }
        else { upd[ln.key] = 0; need = true; }
      });
      var add = (target && !kept) ? { id: target, quantity: 1 } : null;
      var attrs = null;
      if (choice && !(st === 'A' && mixed)) attrs = { 'Lieferart': '' };
      if (need || add || attrs) {
        if (hold) {
          /* Review Runde 3: Warenkorb weicht vom Sollzustand ab und darf nicht automatisch korrigiert werden:
             Kasse gesperrt lassen, bis die Kundin „Erneut versuchen“ wählt oder die Sperre abläuft */
          this.classList.add('is-held');
          this.querySelectorAll('button[name="checkout"]').forEach(function (b) { b.disabled = true; });
        } else {
          var u = need || attrs ? { updates: upd } : null;
          if (u && attrs) u.attributes = attrs;
          this.cartWrite(u, add);
          return;
        }
      }
      if (st !== 'A') return;

      /* Hinweisleiste nur USA/Kanada (Schwelle 200 €). Review 10.10.: „eine Sendung kostenlos“ nur, wenn
         Warenwert + zweite Sendung die Schwelle erreicht, sonst kosten beide Sendungen. */
      if (zone === 'B') {
        var x = formatMoney(Math.max(0, FREE_SHOWN - goods), fmt);
        var txt = '';
        if (!mixed && goods < FREE_MIN) txt = t.BAR_ONE.replace('{x}', x);
        else if (!mixed && goods < FREE_SHOWN) txt = t.BAR_GRACE;
        else if (mixed && goods < FREE_MIN) txt = (goods + FEE_AMT.B >= FREE_MIN ? t.BAR_MIX : t.BAR_MIX_LOW).replace('{x}', x).split('{fee}').join(formatMoney(FEE_AMT.B, fmt));
        else if (mixed) txt = t.BAR_MIX_FREE.replace('{fee}', formatMoney(FEE_AMT.B, fmt));
        if (txt) { bar.textContent = txt; bar.hidden = false; }
      }
      if (!mixed) return;
      box.hidden = false;
      var setChoice = function (v) { box.dataset.choice = v; self.cartWrite({ attributes: { 'Lieferart': v } }, null, true); };
      if (zone === 'A') {
        body.innerHTML = '<p class="lm-cart__split-info">' + esc(t.SPLIT_FREE) + '</p>';
        if (!hold && choice !== 'Teillieferung (kostenlos)') setChoice('Teillieferung (kostenlos)');
        return;
      }
      var part = choice === 'Teillieferung';
      var name = 'lm-split-' + (this.dataset.section || '');
      body.innerHTML =
        '<label class="lm-cart__split-opt"><input type="radio" name="' + name + '" value="Gesamtlieferung"' + (part ? '' : ' checked') + '><span>' + esc(t.SPLIT_ALL) + '</span></label>' +
        '<label class="lm-cart__split-opt"><input type="radio" name="' + name + '" value="Teillieferung"' + (part ? ' checked' : '') + '><span>' + esc(t.SPLIT_PART) +
        '<span class="lm-cart__split-price">' + esc(t.SPLIT_SECOND.replace('{fee}', formatMoney(FEE_AMT[zone], fmt))) + '</span></span></label>';
      if (!hold && choice !== 'Gesamtlieferung' && choice !== 'Teillieferung') setChoice('Gesamtlieferung');
      body.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () {
          /* Auswahl der Kundin = bewusster neuer Versuch, Sperre aufheben */
          try { sessionStorage.removeItem(HOLD_KEY); } catch (e) {}
          var v = r.value, u = {};
          lines.forEach(function (ln) { u[ln.key] = 0; });
          if (v === 'Teillieferung') self.cartWrite({ updates: u, attributes: { 'Lieferart': v } }, { id: FEE_VAR[zone], quantity: 1 });
          else self.cartWrite({ updates: u, attributes: { 'Lieferart': v } }, null);
        });
      });
    }

    /* update.js (Mengen/Attribute), danach optional add.js, dann Abschnitt neu laden (silent = ohne Neuladen).
       Review 10.10.: Kasse und Express-Kauf sind gesperrt, bis der Warenkorb bestätigt ist. Jede Antwort wird
       geprüft. Bei Fehler: Hinweis, keine automatische Wiederholung (HOLD_KEY), Warenkorb neu laden. */
    cartWrite(update, add, silent) {
      var self = this, root = window.LMDest.root();
      this._splitBusy = true;
      this.lock(true);
      var post = function (url, body) {
        return fetch(root + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) { var e = new Error('http ' + r.status); e.status = r.status; throw e; } return r; });
      };
      var p = Promise.resolve();
      if (update) p = p.then(function () { return post('cart/update.js', update); });
      if (add) p = p.then(function () {
        return post('cart/add.js', { items: [add] }).catch(function (e) {
          /* Position nicht hinzufügbar (z. B. Produkt noch nicht veröffentlicht): zurück auf Gesamtlieferung */
          return post('cart/update.js', { attributes: { 'Lieferart': 'Gesamtlieferung' } }).then(function () { throw e; });
        });
      });
      return p.then(function () {
        if (silent) { self._splitBusy = false; self.lock(false); return; }
        return self.refresh();
      }).catch(function () {
        try { sessionStorage.setItem(HOLD_KEY, String(Date.now())); } catch (e) {}
        self._splitBusy = false;
        return self.refresh().catch(function () {
          /* Zustand unbekannt: Kasse bleibt gesperrt, bis „Erneut versuchen“ erfolgreich neu lädt */
          self.classList.add('is-held');
          self.lock(false);
          var er = self.querySelector('[data-lm-split-err]');
          if (er) { er.innerHTML = esc(self.t.SPLIT_ERR) + ' <button type="button" class="lm-cart__split-retry" data-lm-split-retry>' + esc(self.t.SPLIT_RETRY) + '</button>'; er.hidden = false; }
        });
      });
    }

    lock(on) {
      this.classList.toggle('is-busy', on);
      this.classList.toggle('is-locked', on);
      var held = this.classList.contains('is-held');
      this.querySelectorAll('button[name="checkout"]').forEach(function (b) { b.disabled = on || held; });
      if (this.select) this.select.disabled = on;
    }

    mailto(code) {
      var t = this.t, D = window.LMDest, l = this.l;
      var lines = [];
      try { lines = JSON.parse(this.querySelector('[data-lm-cart-lines]').textContent); } catch (e) {}
      var sub = '';
      try { sub = JSON.parse(this.querySelector('[data-lm-cart-subtotal]').textContent); } catch (e) {}
      var body = t.MAIL_INTRO.replace('{to}', D.toPhrase(code, l)) + '\n';
      lines.forEach(function (x) { body += x.q + ' × ' + x.t + (x.c ? ' (' + x.c + ')' : '') + ' – ' + x.p + '\n'; });
      /* v27: FR mit geschuetztem Leerzeichen vor dem Doppelpunkt */
      body += '\n' + t.MAIL_SUB + (l === 'fr' ? '\u00a0: ' : ': ') + sub + '\n';
      body += t.MAIL_END;
      var subj = t.MAIL_SUBJ.replace('{country}', D.countryName(code, l));
      return 'mailto:' + (this.dataset.mail || '') + '?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body);
    }

    /* Mengen und Entfernen: Shopify-Warenkorb aendern, dann Abschnitt neu laden */
    bindQty() {
      var self = this;
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lm-step], [data-lm-set]');
        if (!b) return;
        var li = b.closest('[data-line]');
        if (!li) return;
        var qty = b.hasAttribute('data-lm-set') ? parseInt(b.getAttribute('data-lm-set'), 10)
          : Math.max(0, parseInt(li.dataset.qty, 10) + parseInt(b.getAttribute('data-lm-step'), 10));
        var err = self.querySelector('[data-lm-error]');
        if (b.hasAttribute('data-lm-maxed')) {
          if (err) { err.textContent = self.t.MAXED; err.hidden = false; }
          return;
        }
        /* Review Runde 3: keine Mengenänderung parallel zu einem laufenden Schreibvorgang */
        if (self._splitBusy || self.classList.contains('is-locked')) return;
        self._splitBusy = true;
        self.lock(true);
        /* Auf Bestellung (Loesung C): Tuch und verknuepfte Aufpreise (data-lm-kids) gemeinsam aendern */
        var req;
        if (li.dataset.lmKids && li.dataset.key) {
          var upd = {};
          upd[li.dataset.key] = qty;
          li.dataset.lmKids.split(',').forEach(function (k) { if (k) upd[k] = qty; });
          req = { url: 'cart/update.js', body: { updates: upd } };
        } else {
          req = { url: 'cart/change.js', body: { line: parseInt(li.dataset.line, 10), quantity: qty } };
        }
        fetch(window.LMDest.root() + req.url, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(req.body)
        }).then(function (r) {
          if (!r.ok) {
            self._splitBusy = false; self.lock(false);
            if (err) { err.textContent = self.t.MAXED; err.hidden = false; }
            return null;
          }
          return self.refresh();
        }).catch(function () { self._splitBusy = false; self.lock(false); });
      });
    }

    refresh() {
      var id = this.dataset.section;
      var url = window.location.pathname + '?sections=' + encodeURIComponent(id) + ',cart-icon-bubble';
      /* Review Runde 3: HTTP-Status und vorhandene Section prüfen, sonst Fehler (Aufrufer zeigt Hinweis) */
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(function (s) {
          var p = new DOMParser();
          var ic = document.getElementById('cart-icon-bubble');
          if (s['cart-icon-bubble'] && ic) {
            var d2 = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (d2) ic.innerHTML = d2.innerHTML;
          }
          var host = document.getElementById('shopify-section-' + id);
          var d = s && s[id] ? p.parseFromString(s[id], 'text/html').getElementById('shopify-section-' + id) : null;
          if (!host || !d) throw new Error('section');
          host.innerHTML = d.innerHTML;
        });
    }

    /* Geschenk: Haekchen + Grusstext als Warenkorb-Attribute (gehen mit in die Bestellung) */
    bindGift() {
      var self = this;
      var cb = this.querySelector('[data-lm-gift]');
      var body = this.querySelector('[data-lm-gift-body]');
      var msg = this.querySelector('[data-lm-gift-msg]');
      var count = this.querySelector('[data-lm-gift-count]');
      var noinv = this.querySelector('[data-lm-gift-noinv]');
      if (!cb) return;
      var noinvVal = function () { return noinv && noinv.checked ? 'Ja' : 'Nein'; };
      var save = function (attrs) {
        return fetch(window.LMDest.root() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () {});
      };
      if (/[?&]gift=1/.test(window.location.search) && !cb.checked) {
        cb.checked = true; body.hidden = false; save({ 'Geschenk': 'Ja', 'Ohne Rechnung': noinvVal() });
      }
      cb.addEventListener('change', function () {
        body.hidden = !cb.checked;
        if (cb.checked) { save({ 'Geschenk': 'Ja', 'Ohne Rechnung': noinvVal() }); if (msg) msg.focus(); }
        else { save({ 'Geschenk': '', 'Grußtext': '', 'Ohne Rechnung': '' }); if (msg) { msg.value = ''; count.textContent = '0'; } }
      });
      if (noinv) {
        noinv.addEventListener('change', function () {
          if (cb.checked) save({ 'Ohne Rechnung': noinvVal() });
        });
      }
      if (msg) {
        var timer = null;
        msg.addEventListener('input', function () {
          count.textContent = String(msg.value.length);
          clearTimeout(timer);
          timer = setTimeout(function () {
            save({ 'Grußtext': msg.value });
          }, 600);
        });
      }
    }

    /* Gutschein- oder Rabattcode: Shopify-Warenkorb (discount) -> Checkout uebernimmt den Code */
    flash(k, ok, code) {
      var m = this.querySelector('[data-lm-code-msg]');
      if (!m) return;
      m.textContent = (this.t[k] || '').split('{code}').join(code || '');
      m.className = 'lm-cart__code-msg ' + (ok ? 'is-ok' : 'is-err');
      m.hidden = false;
      var body = this.querySelector('[data-lm-code-body]');
      var tg = this.querySelector('[data-lm-code-toggle]');
      if (body) body.hidden = false;
      if (tg) tg.setAttribute('aria-expanded', 'true');
    }

    bindCode() {
      var self = this;
      var tg = this.querySelector('[data-lm-code-toggle]');
      var body = this.querySelector('[data-lm-code-body]');
      var input = this.querySelector('[data-lm-code-input]');
      var btn = this.querySelector('[data-lm-code-apply]');
      if (!tg || !body) return;
      tg.addEventListener('click', function () {
        var open = tg.getAttribute('aria-expanded') !== 'true';
        tg.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.hidden = !open;
        if (open && input) input.focus();
      });
      /* aktuell gueltige Codes direkt aus dem Shopify-Warenkorb */
      var current = function () {
        return fetch(window.LMDest.root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) { return (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }); });
      };
      var send = function (codes) {
        return fetch(window.LMDest.root() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: codes.join(',') })
        }).then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); });
      };
      var apply = function () {
        var code = (input.value || '').trim();
        if (!code) { self.flash('CODE_EMPTY', false); input.focus(); return; }
        var before = [];
        btn.disabled = true;
        current().then(function (list) {
          before = list;
          if (before.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) { btn.disabled = false; self.flash('CODE_OK', true, code); return null; }
          return send(before.concat([code]));
        }).then(function (cart) {
          if (!cart) return;
          var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toLowerCase() === code.toLowerCase(); })[0];
          if (hit && hit.applicable) {
            window.__lmCartFlash = { k: 'CODE_OK', ok: true, code: hit.code };
            return self.refresh();
          }
          /* ungueltigen Code wieder entfernen, gueltige behalten */
          return send(before).then(function () { btn.disabled = false; self.flash('CODE_BAD', false, code); });
        }).catch(function () { btn.disabled = false; self.flash('CODE_ERR', false); });
      };
      if (btn) btn.addEventListener('click', apply);
      if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
      this.querySelectorAll('[data-lm-code-remove]').forEach(function (b) {
        b.addEventListener('click', function () {
          var drop = b.getAttribute('data-lm-code-remove').toLowerCase();
          b.disabled = true;
          current()
            .then(function (list) { return send(list.filter(function (c) { return c.toLowerCase() !== drop; })); })
            .then(function () { return self.refresh(); })
            .catch(function () { b.disabled = false; self.flash('CODE_ERR', false); });
        });
      });
    }
  }
  window.customElements.define('lm-cart', LmCart);
})();
